<!-- <app-top-promo [isMobile]="isMobile"></app-top-promo> -->
<div class="homePage">

    <app-header [isMobile]="isMobile" [isHome]="isHome"></app-header>
    <div class="headerSpacer"></div>

    <app-home-slider [data]="data" [isMobile]="isMobile"></app-home-slider>

    <div class="homePromoWrapper">

        <div class="title" *ngIf="isMobile">
            <div class="line"></div>
            <div class="txt">Streaming on:</div>
        </div>

        <a href="https://50centaction.com" target="_blank" class="homePromo">
            <img [src]="!isMobile ? 'assets/img/50CentAction_promo-desktop-v2.jpg' : 'assets/img/50centaction_mobile-streaming-now-on-v2.jpg' "
                alt="">
            <div class="border"></div>
        </a>


        <!-- <div class="sectionTitle">
            <div class="line"></div>
            <div class="txt">Series Channels</div>
        </div> -->

        <!-- <a href="https://50centaction.com" target="_blank" class="homePromo">
            <img [src]="!isMobile ? 'assets/img/50CentAction_promo-desktop-v2.jpg' : 'assets/img/50centaction_mobile-streaming-now-on-v2.jpg' "
                alt="">
            <div class="border"></div>
        </a> -->
<!-- 
        <a href="https://50centaction.com"  class="homePromo">
            <img [src]="!isMobile ? 'assets/img/50CentAction_promo-desktop-v2.jpg' : 'assets/img/50centaction_mobile-streaming-now-on-v2.jpg' "
                alt="">
            <div class="border"></div>
        </a>

        <a [href]="rootPath + data.showList[0].url" target="_blank" class="homePromo">
            <img [src]="data.showList[0].thumb" alt="">
            <div class="border"></div>
        </a>
        <a [routerLink]="data.showList[1].url" class="homePromo">
            <img [src]="data.showList[1].thumb" alt="">
            <div class="border"></div>
        </a> -->
    </div>

    <!-- <a [routerLink]="item.url" *ngFor="let item of data.showList">
        {{item.url}}
        <img [src]="item.thumb" alt="">
    </a> -->


    <app-home-show-list [data]="data" [isMobile]="isMobile"></app-home-show-list>

    <app-footer></app-footer>
</div>

<div class="sizzleBg" [ngClass]="{open: pageDataService.isOverlayOpen}"></div>
<app-sizzle-overlay></app-sizzle-overlay>